module.exports = __webpack_public_path__ + "img/Logo MM Alta vertical-blanco.0ccfac87.png";